import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, flatMap, tap, takeUntil } from 'rxjs/operators';
import { ItemService } from '../services';

@Component({
    selector: 'edit-topic-content-source-preview',
    template: `
        <div *ngIf="noTouching" fxLayoutAlign="center center"><spinner></spinner></div>
        <div *ngIf="items?.value?.length" fxFlex fxLayout="column">
            <table mat-table #table [dataSource]="items"  fxFlex style="width: 100%;">
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef>Title</th>
                    <td mat-cell *matCellDef="let row" style="overflow: hidden; white-space: nowrap;">
                        <div style="text-overflow: ellipsis; overflow: hidden;" [matTooltip]="row.title">{{row.title}}</div>
                    </td>
                </ng-container>
                <tr mat-row *matRowDef="let row; columns: ['title'];"></tr>
            </table>
            <div *ngIf="noTouchingPaging" fxLayoutAlign="center center"><spinner></spinner></div>
        </div>
        <div *ngIf="!noTouching && items?.value && !items?.value?.length">
            <h5>No items contributed by this source</h5>
        </div>
    `
})
export class EditTopicContentSourcePreviewComponent implements OnChanges, OnDestroy, OnInit {
    @Input() topic;
    @Input() source;
    private cleanupTime = new Subject<void>();
    searchParams = new BehaviorSubject<any>({ page: 0 });
    items = new BehaviorSubject<any[]>([]);
    isLastPage: boolean;
    noTouching = true;
    noTouchingPaging = true;

    constructor(private itemService: ItemService) {}

    ngOnInit(): void {
        this.searchParams.pipe(
            filter(params => params.streamId),
            flatMap(params => this.itemService.searchItemsWithSettings({ search: params.search, page: params.page, publishedWithinDays: params.publishedWithinDays }, { streamId: params.streamId, sortField: 'publishedDate' })),
            tap(() => this.noTouching = false),
            tap(() => this.noTouchingPaging = false),
            tap(results => this.isLastPage = results.last),
            takeUntil(this.cleanupTime)
        ).subscribe(results => {
            this.items.next(this.items.value.concat(results.content));
        });
    }

    ngOnChanges(): void {
        if (this.source && this.topic) {
            let publishedWithinDays = this.topic.filter && this.topic.filter.publishedWithinDays ? this.topic.filter.publishedWithinDays : undefined;

            this.searchParams.next(Object.assign({}, this.searchParams.value, { 
                search: this.topic.filter ? this.topic.filter.filterTerm : undefined,
                streamId: this.source.id, 
                page: 0,
                publishedWithinDays 
            }));
        }
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}